module.exports = __webpack_public_path__ + "img/product-tizen-complete-package-with-arrows.7f2912ce.jpg";